<template>
    <select ref="el"><slot></slot></select>
</template>

<script>
import $ from 'jquery';

export default {
    name: 'Select2',
    props: {
        options: { type: Array, default: () => [] },
        modelValue: { default: null },
        settings: { type: Object, default: () => ({}) },
        placeholder: { type: String, default: '' },
    },
    emits: ['update:modelValue'],

    mounted() {
        const vm = this;
        $(this.$refs.el)
            .select2({
                data: this.options,
                placeholder: this.placeholder,
                allowClear: !!this.placeholder,
                width: '100%',
                ...this.settings,
            })
            .val(this.modelValue)
            .trigger('change')
            .on('change', function () {
                vm.$emit('update:modelValue', $(this).val());
            });
    },

    watch: {
        modelValue(val) {
            $(this.$refs.el).val(val).trigger('change.select2');
        },
        options(val) {
            const $el = $(this.$refs.el);
            $el.empty();
            $el.select2({
                data: val,
                placeholder: this.placeholder,
                allowClear: !!this.placeholder,
                width: '100%',
                ...this.settings,
            });
        },
    },

    unmounted() {
        $(this.$refs.el).off().select2('destroy');
    },
};
</script>
